import { request } from "../request";
import { isHXApp } from "@saas/components/src";
const mock = "";
// const mock = "https://yapi.upho2015.com/mock/530";
export const getCourseInfo = (params) =>
  request(`/v1/course/info`, "get", {
    params: {
      answer_type: isHXApp() ? 1 : 0,
      ...params,
    },
  });
export const createOrder = (params) =>
  request(`/v1/order/create`, "POST", { json: params });
export const getOrder = (params) => request(`/v1/order/get`, "get", { params });
export const createEnrollment = (params) =>
  request(`/v1/enrollment/create`, "post", { json: params });
export const chargeOrder = (params) =>
  request(`/v1/order/charge`, "post", { json: params });
export const checkOrder = (params) =>
  request(`/v1/order/checkOrder`, "post", { json: params });

// 拼团
export const getByCourseId = (params) =>
  request(`${mock}/v1/groupBuying/getByCourseId`, "get", {
    params,
  });

export const getGroupBuying = (params) =>
  request(`${mock}/v1/groupBuying/get`, "get", {
    params,
  });

// 获取微信小程序地址
export const getWxMiniProgramUrl = (params) =>
  request(`${mock}/v1/auth/wechat/getUrlScheme`, "post", {
    json: params,
  });

// 绑定课程学生
export const bindCourseStudent = (params) =>
  request(`/v1/enrollment/bind`, "post", { json: params });
